<template>
  <v-container
    style="padding: 0; margin: 10px;"
    fill-height
    fluid
    grid-list-xl>
    <v-layout
      v-if="id || novo"
      justify-center
      wrap
    >
      <v-flex xs12>
        <h2>Ajuda #{{ id && id !== null ? ajuda.id : 'Novo' }}</h2>
      </v-flex>
      <v-flex xs12>
        <v-card>
          <v-layout
            row
            wrap>
            <v-flex xs12>
              <div style="padding: 10px;">
                <label for="titulo">
                  <strong>Titulo *:</strong>
                </label>
                <v-textarea
                  id="titulo"
                  v-model="ajuda.titulo"
                  outline/>
              </div>
            </v-flex>
            <v-flex xs6>
              <div style="padding: 10px;">
                <label for="rota">
                  <strong>Rota *:</strong>
                </label>
                <v-autocomplete
                  id="rota"
                  v-model="ajuda.rota"
                  :items="rotasPossiveis"
                  :browser-autocomplete="rand()"
                  outline
                  no-data-text=""
                  class="purple-input"
                />
              </div>
            </v-flex>
            <v-flex xs6>
              <div style="padding: 10px;">
                <label for="etapa">
                  <strong>Etapa (se necessário):</strong>
                </label>
                <v-text-field
                  id="etapa"
                  v-model="ajuda.etapa"
                  outline/>
              </div>
            </v-flex>
            <v-flex xs12>
              <div style="padding: 10px;">
                <label for="youtube">
                  <strong>Vídeo Youtube (apenas o código) *:</strong>
                </label>
                <v-text-field
                  id="youtube"
                  v-model="ajuda.video"
                  outline/>
              </div>
            </v-flex>
            <v-flex xs12>
              <div style="padding: 10px;">
                <label for="ajuda">
                  <strong>Referente a *:</strong>
                </label>
                <v-checkbox
                  id="ajuda"
                  v-model="ajuda.web"
                  label="WEB"/>
                <v-checkbox
                  v-model="ajuda.mobile"
                  label="MOBILE"/>
              </div>
            </v-flex>
            <v-flex xs12>
              <label for="idioma">
                <strong>Idioma *:</strong>
              </label>
              <v-radio-group
                id="idioma"
                v-model="ajuda.idioma"
                v-bind="binding"
                row
                class="purple-input"

              >
                <br>
                <v-radio
                  :label="'Português'"
                  :value="0"
                  color="primary"
                />
                <br>
                <v-radio
                  :label="'English'"
                  :value="1"
                  color="primary"
                />
                <br>
                <v-radio
                  :label="'Español'"
                  :value="2"
                  color="primary"
                />
              </v-radio-group>
            </v-flex>
            <v-flex xs12>
              <div style="padding: 10px;">
                <strong>Descrição do Vídeo ou Ajuda:</strong>
                <v-textarea
                  v-model="ajuda.descricao"
                  outline/>
              </div>
            </v-flex>
            <v-flex xs6>
              <v-btn @click="voltar">Voltar</v-btn>
            </v-flex>
            <v-flex xs6>
              <v-btn
                color="success"
                @click="salvar">Salvar</v-btn>
            </v-flex>

          </v-layout>
        </v-card>
      </v-flex>

    </v-layout>
    <v-layout
      v-else
      justify-center
      wrap
    >
      <template v-if="ajudas">
        <v-flex xs12>
          <h2>Ajudas Cadastradas</h2>
          <v-btn href="/adm/ajuda?novo=true">Adicionar Ajuda</v-btn>
        </v-flex>
        <v-flex>
          <v-card style="height: 600px; overflow: auto; font-size: 20px!important">
            <v-list
              two-line
              dense>
              <v-list-tile
                v-for="ajuda in ajudas"
                :key="ajuda.id"
                style="padding: 20px;"
                @click="(rem) ? removeAjuda(ajuda) : openAjuda(ajuda)">
                <v-list-tile-content>
                  #{{ ajuda.id }} - {{ ajuda.titulo.trimEllip(50) }} <small>{{ ajuda.rota }} - {{ ajuda.etapa }} - <span>{{ ajuda.web ? 'WEB' : '' }} - {{ ajuda.mobile ? 'MOBILE': '' }}</span> - {{ ajuda.idioma === 0 ? 'PT-BR' : ajuda.idioma === 1 ? 'EN' : 'ES' }}</small>
                </v-list-tile-content>
                <v-list-tile-action>
                  <a
                    href="javascript:void(0);"
                    style="color: red"
                    @click="rem = true;">X</a>
                </v-list-tile-action>
              </v-list-tile>
            </v-list>
          </v-card>
        </v-flex>
      </template>
    </v-layout>

  </v-container>
</template>
<style scoped>
strong{
  font-size: 20px;
}
</style>

<script>
import paths from '../../router/paths'
import moment from 'moment'
import { estados, paises } from '../../lang/Strings'
import { mapState } from 'vuex'
import {
  replaceSpecialChars
} from '@/utils/vuex'
import { EMPRESA_GESTOR, EMPRESA_GERENTE_REGIONAL, EMPRESA_TECNICO_VENDA, EMPRESA_PRODUTOR_VINCULADO, EMPRESA_TIPOS } from '../../utils/types'
export default {
  data: () => ({
    id: null,
    novo: false,
    rep: false,
    ajuda: null,
    ajudas: null,
    empUser: null,
    user: null,
    users: [],
    empresas: [],
    cargo: null,
    searchEmpresas: null,
    empresa: null,
    empresa_: null,
    loading: false,
    cnpjRules: null,
    EMPRESA_GESTOR: EMPRESA_GESTOR,
    EMPRESA_GERENTE_REGIONAL: EMPRESA_GERENTE_REGIONAL,
    EMPRESA_TECNICO_VENDA: EMPRESA_TECNICO_VENDA,
    EMPRESA_PRODUTOR_VINCULADO: EMPRESA_PRODUTOR_VINCULADO,
    EMPRESA_TIPOS: EMPRESA_TIPOS
  }),
  computed: {
    ...mapState('app', ['idioma', 'strings', 'empresa', 'acesso']),
    rotasPossiveis () {
      return paths.map(p => p.path.substring(1))
    },
    heightCard () {
      return String(this.$vuetify.breakpoint.height - 289) + 'px'
    },
    heightDialog () {
      return this.$vuetify.breakpoint.xs ? String(this.$vuetify.breakpoint.height - 150) + 'px' : String(this.$vuetify.breakpoint.height - 240) + 'px'
    },
    heightempresaOverflow () {
      return 'max-height: ' + String(this.$vuetify.breakpoint.height - 20) + 'px; overflow: auto;'
    },
    heightOverflow () {
      return 'max-height: ' + String(this.$vuetify.breakpoint.height - 50) + 'px; overflow: auto;'
    },
    heightTree () {
      return 'max-height: ' + String(this.$vuetify.breakpoint.height - 330) + 'px; overflow: auto; min-height: 200px;'
    },
    Usuarios () {
      return this.users
    },
    Cargos () {
      return [
        { 'nome': this.strings[this.idioma]['empresa_gestor'], 'nivel': 0, 'id': 'empresa_gestor' },
        { 'nome': this.strings[this.idioma]['empresa_gerente_regional'], 'nivel': 1, 'id': 'empresa_gerente_regional' },
        { 'nome': this.strings[this.idioma]['empresa_tecnico_venda'], 'nivel': 2, 'id': 'empresa_tecnico_venda' },
        { 'nome': this.strings[this.idioma]['empresa_produtor_vinculado'], 'nivel': 3, 'id': 'empresa_produtor_vinculado' }

      ]
    },
    UnidadesFederativas () {
      return estados
    },
    Cidades () {
      let cidades = estados.filter(e => e.sigla === this.empresa_.endereco.estado)
      return cidades.length > 0 ? cidades[0].cidades : []
    },
    Paises () {
      return paises
    },
    Proprietario () {
      let prop = this.users.filter(u => u.id === this.empresa_.id_proprietario)
      return prop.length > 0 ? prop[0] : []
    },
    Empresas () {
      return this.empresas
    },
    empresasFilter () {
      if (this.searchEmpresas === null || this.searchEmpresas.trim() === '') return this.empresas
      return this.empresas.filter(u => new RegExp(replaceSpecialChars(this.searchEmpresas.toLowerCase()), 'i').test(u.nome))
    }
  },
  created () {
    this.queryWork()
    this.axios.post('users/get', {}).then(r => { this.users = r.data.data.users }).catch(() => this.$router.push('/'))
    this.axios.post('ajuda', (this.id !== null) ? { id: this.id } : null).then(res => {
      this.ajudas = res.data.data
      if (this.id !== null) {
        this.ajuda = this.ajudas
      }
    })
  },
  methods: {
    removeAjuda (ajuda) {
      delete this.rem
      if (confirm(this.strings[this.idioma].msg_remove)) {
        this.axios.post('ajuda/remove', { id: ajuda.id }).then(res => {
          window.location.href = '/adm/ajuda'
        })
      }
    },
    openAjuda (ajuda) {
      if (this.rem && this.rem === true) return
      const url = '/adm/ajuda?id=' + ajuda.id
      window.location.href = url
    },
    salvar () {
      this.axios.post('ajuda/create', this.ajuda).then(res => {
        alert('Salvo com sucesso!!!')
        window.location.href = '/adm/ajuda'
      })
    },
    responder () {
      let msg = prompt('Qual a sua resposta')
      this.axios.post('reporte/enviar', { id: this.id, msg: msg }).then(res => {
        alert('Resposta enviada com sucesso para o e-mail do dono desse reporte')
      })
    },
    queryWork () {
      if (this.$route.query.id) {
        this.id = parseInt(this.$route.query.id)
      } else if (this.$route.query.novo) {
        this.novo = true
        this.ajuda = {
          'titulo': null,
          'descricao': null,
          'rota': null,
          'etapa': null,
          'video': null,
          'web': false,
          'mobile': false
        }
      }
    },
    moment (...args) {
      return moment(...args)
    },
    vincular (emp) {
      this.empresa = emp
      if (this.empUser !== null) {
        this.empUser.id_empresa = emp.id
        this.empUser.empresa = emp
      }
    },
    desvincula () {
      let empresa = this.empresa
      let usuario = this.user
      let cargo = this.cargo
      console.log(this.Cargos.filter(c => cargo === c.nome)[0], cargo)
      let acesso = this.Cargos.filter(c => cargo === c.nome)[0].nivel
      this.axios.post('empresa/desvincula', { id_empresa: empresa.id, id_pessoa: usuario.id, acesso: acesso }).then(response => {
        let msg = 'Desvinculado!!!'
        let title = ''
        this.$store.commit('openOKModal', { title, msg })
        this.voltar()
      })
    },
    cadastra () {
      let empresa = this.empresa
      console.log(this.empresa)
      let usuario = this.user
      let cargo = this.cargo
      let acesso = this.Cargos.filter(c => cargo === c.nome)[0].nivel
      this.axios.post('empresa/vincula', { id_empresa: empresa.id, id_pessoa: usuario.id, acesso: acesso }).then(response => {
        let msg = 'Vinculado!!!'
        let title = ''
        this.$store.commit('openOKModal', { title, msg })
        this.voltar()
      })
    },
    changeProprietario () {
      let prop = this.users.filter(u => u.email === this.empresa_.email_proprietario)[0]
      this.empresa_.id_proprietario = prop.id
    },
    voltar () {
      window.history.back()
    },
    parseString (valor, idioma) {
      if ((idioma === 0 || idioma === 2) && valor && valor !== '-') {
        if (valor[valor.length - 3] === '.') return parseFloat(valor)
        return parseFloat(valor.replace(/[.]/g, '').replace(/[,]/g, '.'))
      } else if (valor && valor !== '-') {
        return parseFloat(valor.replace(/[,]/g, ''))
      }
      return 0
    },
    cnpjValidator (val, input, tipo) {
      return this.$testaCNPJ(String(input[tipo]))
    },
    reset () {
      this.empresa_ = Object.assign({}, this.empresa)
    },
    update () {
      this.axios.post('empresa/create', { id: this.empresa.id, id_proprietario: this.Proprietario.id, email: this.empresa_.email, email_financeiro: this.empresa_.email_financeiro, nome: this.empresa_.nome, nome_fantasia: this.empresa_.nome_fantasia, razao_social: this.empresa_.razao_social, inscricao_estadual: this.empresa_.inscricao_estadual, telefone: this.empresa_.telefone, telefoneFinanceiro: this.empresa_.telefoneFinanceiro, endereco: this.empresa_.endereco, enderecoFinanceiro: this.empresa_.enderecoFinanceiro, cnpj: this.empresa_.cnpj, EXCLUIDO: this.empresa_.EXCLUIDO, permissao: this.empresa_.permissao }).then(response => {
        this.empresa.nome = this.empresa_.nome
        this.empresa.email = this.empresa_.email
        this.empresa.email_financeiro = this.empresa_.email_financeiro
        this.empresa.id_proprietario = this.empresa_.id_proprietario
        this.empresa.razao_social = this.empresa_.razao_social
        this.empresa.nome_fantasia = this.empresa_.nome_fantasia
        this.empresa.endereco = this.empresa_.endereco
        this.empresa.telefone = this.empresa_.telefone

        this.empresa.enderecoFinanceiro = this.empresa_.enderecoFinanceiro
        this.empresa.telefoneFinanceiro = this.empresa_.telefoneFinanceiro
        this.empresa.cnpj = this.empresa_.cnpj
        this.empresa.EXCLUIDO = this.empresa_.EXCLUIDO
        this.empresa.permissao = this.empresa.permissao
        let msg = this.strings[this.idioma].cadastrado
        let title = this.strings[this.idioma].editar_perfil
        this.$store.commit('openOKModal', { title, msg })
        this.voltar()
      })
    },
    mudarSenha () {
      this.loading = true
      this.axios.post('/auth/esqueciSenha', { email: this.empresa.email }).then(response => {
        this.loading = false
        let msg = this.strings[this.idioma].enviado
        let title = this.strings[this.idioma].mudanca_senha
        this.$store.commit('openOKModal', { title, msg })
      }).catch(reason => {
        this.loading = false
        let msg = this.strings[this.idioma].usuario_nao_encontrado
        let time = 6000
        this.$store.commit('openErrorAlert', { msg, time })
      })
    },
    verificaEmail (fn = null, fncatch = null) {
      if (this.empresa_.email.trim() === this.empresa.email.trim()) {
        fncatch(this.empresa.email)
        return
      }
      this.axios.post('/auth/verificaEmail', { email: this.empresa_.email }).then(() => {
        this.empresa_.email = this.empresa.email
        let msg = 'E-Mail já existente!!!'
        let time = 6000
        this.$store.commit('openErrorAlert', { msg, time })
        if (fn !== null) {
          fn(this.empresa_.email)
        }
      }).catch(() => {
        if (fncatch !== null) {
          fncatch(this.empresa_.email)
        }
      })
    },
    rand () {
      return Math.random()
    }
  }
}
</script>
